import React from 'react';

const ROLE_CLASS: Record<string, string> = {
  admin: 'text-rose-300 bg-rose-400/10 border-rose-400/30',
  mentor: 'text-violet-300 bg-violet-400/10 border-violet-400/30',
  sales: 'text-orange-300 bg-orange-400/10 border-orange-400/30',
  vip: 'text-amber-300 bg-amber-400/10 border-amber-400/30',
  member: 'text-cyan-300 bg-cyan-400/10 border-cyan-400/30',
  webinar: 'text-sky-300 bg-sky-400/10 border-sky-400/30',
  workshop: 'text-emerald-300 bg-emerald-400/10 border-emerald-400/30',
};

const ROLE_TEXT: Record<string, string> = {
  webinar: 'Webinar',
  workshop: 'Workshop',
};

export function roleBadgeClass(role: string): string {
  return ROLE_CLASS[(role || '').toLowerCase()] || 'text-white/60 bg-white/5 border-white/15';
}

export function RoleBadge({ role }: { role: string }) {
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full border ${roleBadgeClass(role)}`}
    >
      {ROLE_TEXT[(role || '').toLowerCase()] || role}
    </span>
  );
}
